import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { StoreRootState } from 'services/store/types';
import { SubscriptionType } from 'services/api/entities';

const useSubscription = () => {
  const subscriptionType = useSelector(
    (store: StoreRootState) => store.user.subscriptionType
  );
  const subscription = useSelector(
    (store: StoreRootState) => store.user.subscription
  );

  const hasDistribution = useSelector(
    (store: StoreRootState) => store.user.hasDistribution
  );

  const isSubscriptionActive = useMemo(() => {
    if (!subscription) return false;
    return (
      subscription.status === 'active' ||
      subscription.status === 'cancellation_requested'
    );
  }, [subscription]);

  const isSubscriptionCancellationRequested = useMemo(() => {
    if (!subscription) return false;
    return subscription.status === 'cancellation_requested';
  }, [subscription]);

  const subscriptionStatus = useMemo(() => {
    if (!subscription) return null;
    return subscription.status;
  }, [subscription]);

  const isFreeAccount = subscriptionType === SubscriptionType.FREE;
  const isPersonalAccount = subscriptionType === SubscriptionType.PERSONAL;
  const isProAccount = subscriptionType === SubscriptionType.PRO;

  return {
    isSubscriptionActive,
    isSubscriptionCancellationRequested,
    subscription,
    subscriptionType,
    subscriptionStatus,
    hasDistribution,
    isFreeAccount,
    isPersonalAccount,
    isProAccount,
  };
};

export default useSubscription;
